import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { AppConfigFromAssets } from "@momhunting/core";
import { ApiResponseDTO, CmsFeature, CmsFeatureStatus, CmsFeatureType } from "@momhunting/platform-pages";

fetch("./assets/config.json")
  .then((response) => response.json())
  .then((config: AppConfigFromAssets) => {
    fetch(config.apiEndpointUrl + "/cms-data/features")
      .then((response) => response.json())
      .then((responseJSON) => (responseJSON as ApiResponseDTO).results.data as Array<CmsFeature> | [])
      .then((features) => {
        config.featureStatus = deserializeCmsFeatures(features);

        // Add brand class to body
        if (config.brand) {
          document.body.classList.add(`${config.brand}`);
        }

        const AppModuleWithProviders = AppModule.configure(config) as any;

        platformBrowserDynamic(AppModuleWithProviders.providers)
          .bootstrapModule(AppModuleWithProviders.ngModule)
          .catch((err) => console.error(err));
      });
  })
  .catch((_) => {
    console.error("Could not read config.json");
  });

export function deserializeCmsFeatures(dto: Array<CmsFeature>): CmsFeatureStatus {
  return {
    communityLink: dto.find((f) => f.name == CmsFeatureType.COMMUNITY_LINK)?.status || false,
    profilePreviewLink: dto.find((f) => f.name == CmsFeatureType.PROFILE_PREVIEW_LINK)?.status || false,
    englishSite: dto.find((f) => f.name == CmsFeatureType.ENGLISH_SITE)?.status || false,
    mpForMp: dto.find((f) => f.name == CmsFeatureType.MP_FOR_MISSION_PARTNER)?.status || false,
    mpForTalent: dto.find((f) => f.name == CmsFeatureType.MP_FOR_TALENT)?.status || false,
    showKeysSwitch: dto.find((f) => f.name == CmsFeatureType.SHOW_KEYS_SWITCH)?.status || false,
    talentProfileShowMomSkills:
      dto.find((f) => f.name == CmsFeatureType.TALENT_PROFILE_SHOW_MOM_SKILLS)?.status || false,
    talentProfileFamilyFriendlyEmployer:
      dto.find((f) => f.name == CmsFeatureType.TALENT_PROFILE_FAMILY_FRIENDLY_EMPLOYER)?.status || false,
    talentProfileShowGender: dto.find((f) => f.name == CmsFeatureType.TALENT_PROFILE_SHOW_GENDER)?.status || false,
    mpShowMaturityAssessment: dto.find((f) => f.name == CmsFeatureType.MP_SHOW_MATURITY_ASSESSMENT)?.status || false,
    jobOpportunityPublishing: dto.find((f) => f.name == CmsFeatureType.JOB_OPPORTUNITY_PUBLISHING)?.status || false,
  };
}
